import React from 'react'
import {
  Container,
  Heading,
  Text,
  Box,
  Divider,
  VStack
} from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

const Privacy = () => {
  const { t } = useTranslation()
  const effectiveDate = '2025-07-21'

  return (
    <Container maxW="container.lg" py={8}>
      <VStack spacing={6} align="stretch">
        <Box>
          <Heading as="h2" size="md" mb={2}>
            {t('1. 개인정보의 수집 및 처리 목적')}
          </Heading>
          <Text mb={1}>
            {t(
              '회사는 회원 가입 및 서비스 제공을 위해 아래와 같은 개인정보를 수집·처리합니다.'
            )}
          </Text>
          <Text mb={1}>
            - <strong>{t('아이디')}</strong>:{' '}
            {t('회원 식별 및 서비스 이용을 위한 기본 정보')}
          </Text>
          <Text mb={1}>
            - <strong>{t('비밀번호')}</strong>:{' '}
            {t(
              '회원 인증을 위한 정보 (비밀번호는 해시화되어 저장되므로, 관리자도 원본을 확인할 수 없습니다)'
            )}
          </Text>
          <Text mb={1}>
            - <strong>{t('비밀번호 확인')}</strong>:{' '}
            {t('회원 가입 시 비밀번호 입력의 정확성을 검증하기 위한 정보')}
          </Text>
          <Text mb={1}>
            - <strong>{t('이름')}</strong>: {t('본인 확인을 위한 기본 정보')}
          </Text>
          <Text mb={1}>
            - <strong>{t('핸드폰번호')}</strong>:{' '}
            {t('본인 확인 및 고객지원, 중요 알림 제공을 위한 정보')}
          </Text>
          <Text mb={1}>
            - <strong>{t('추천인 아이디')}</strong>:{' '}
            {t('회원 가입 경로 파악 및 관련 혜택 제공을 위한 정보 (선택사항)')}
          </Text>
          <Text mb={1}>
            - <strong>{t('거래소 API 키')}</strong>:{' '}
            {t(
              '봇 사용 시 자동매매를 위한 거래소 연동 정보 (사용자가 명시적으로 등록한 경우에 한함)'
            )}
          </Text>
          <Text>
            - <strong>{t('거래소 API 시크릿')}</strong>:{' '}
            {t(
              '봇 사용 시 자동매매를 위한 인증 정보 (사용자 요청에 따라만 사용됩니다)'
            )}
          </Text>
        </Box>

        <Divider />
        <Box>
          <Heading as="h2" size="md" mb={2}>
            {t('2. 개인정보의 처리 및 보유 기간')}
          </Heading>
          <Text>
            {t(
              '회사는 회원의 개인정보를 서비스 제공 기간 동안 처리 및 보유하며, 회원 탈퇴 또는 서비스 종료 후 관련 법령에 따라 정해진 기간 동안 보관 후 안전하게 파기합니다.'
            )}
          </Text>
        </Box>

        <Divider />
        <Box>
          <Heading as="h2" size="md" mb={2}>
            {t('3. 개인정보의 제3자 제공')}
          </Heading>
          <Text>
            {t(
              '회사는 원칙적으로 회원의 개인정보를 제3자에게 제공하지 않습니다. 단, 다음의 경우에는 예외로 합니다.'
            )}
          </Text>
          <Text mb={1}>- {t('회원의 사전 동의를 받은 경우')}</Text>
          <Text>
            -{' '}
            {t(
              '관련 법령에 의거하거나 수사 목적으로 법률에 정해진 절차와 방법에 따라 수사기관의 요청이 있는 경우'
            )}
          </Text>
        </Box>

        <Divider />
        <Box>
          <Heading as="h2" size="md" mb={2}>
            {t('4. 개인정보 처리 업무의 위탁')}
          </Heading>
          <Text>
            {t(
              '회사는 서비스 제공을 위해 필요한 경우, 회원의 개인정보 처리를 외부 전문 업체에 위탁할 수 있습니다. 위탁 시, 관련 법령에 따른 개인정보 보호 조치를 마련하고, 위탁 계약에 개인정보 보호 책임 사항을 명시합니다.'
            )}
          </Text>
        </Box>

        <Divider />
        <Box>
          <Heading as="h2" size="md" mb={2}>
            {t('5. 개인정보의 파기')}
          </Heading>
          <Text>
            {t(
              '회사는 개인정보 처리 목적이 달성되거나 회원이 탈퇴하는 경우, 지체 없이 개인정보를 파기합니다. 단, 관련 법령에서 정한 보존 기간이 있는 경우 해당 기간 동안 안전하게 보관한 후 파기합니다.'
            )}
          </Text>
        </Box>

        <Divider />
        <Box>
          <Heading as="h2" size="md" mb={2}>
            {t('6. 이용자의 권리 및 행사 방법')}
          </Heading>
          <Text>
            {t(
              '회원은 언제든지 등록된 개인정보에 대해 열람, 정정, 삭제, 처리 정지 등의 권리를 행사할 수 있으며, 관련 요청은 개인정보 보호 책임자에게 연락하여 처리할 수 있습니다.'
            )}
          </Text>
        </Box>

        <Divider />
        <Box>
          <Heading as="h2" size="md" mb={2}>
            {t('7. 개인정보의 안전성 확보 조치')}
          </Heading>
          <Text>
            {t(
              '회사는 개인정보의 안전한 처리를 위하여 관리적, 기술적, 물리적 조치를 강구합니다. 특히, 비밀번호는 해시화되어 저장되며, 그 외 개인정보에 대해서도 암호화 및 접근 제한 등 적절한 보안 조치를 적용합니다.'
            )}
          </Text>
        </Box>

        <Divider />
        <Box>
          <Heading as="h2" size="md" mb={2}>
            {t('8. 개인정보 처리방침의 변경')}
          </Heading>
          <Text>
            {t(
              '본 개인정보 처리방침은 관련 법령 및 회사의 정책에 따라 변경될 수 있으며, 변경 시 회사 홈페이지 및 기타 적절한 방법을 통해 회원에게 공지합니다.'
            )}
          </Text>
        </Box>

        <Divider />
        <Box>
          <Heading as="h2" size="md" mb={2}>
            {t('부칙')}
          </Heading>
          <Text>
            {t('본 개인정보 처리방침은 {{date}}부터 적용됩니다.', {
              date: effectiveDate
            })}
          </Text>
        </Box>
      </VStack>
    </Container>
  )
}

export default Privacy
